// Single source of truth for the privacy policy link used both underneath the
// forms (legal consent checkbox) and in the cookie consent pop-up.
//
// The target is configured at the subdomain level (site.privacyPolicyUrl) so it
// can point either to the on-site privacy policy page (an internal path such as
// "/privacy-policy") or to an external page (a full URL such as
// "https://example.com/privacy"). The shared Link component already resolves
// internal vs external from the value itself: a single leading slash means an
// on-site route, anything else is an external link.

export const DEFAULT_PRIVACY_POLICY_URL = '/privacy-policy';

export const resolvePrivacyPolicyUrl = (url) => {
  const trimmed = typeof url === 'string' ? url.trim() : '';

  return trimmed || DEFAULT_PRIVACY_POLICY_URL;
};

// External links (full URLs starting with http) open in a new tab; on-site
// paths navigate in place.
export const isExternalPrivacyPolicyUrl = (url) => /^https?:\/\//i.test(`${url}`);
